export class Retailer {

    id: number;
    code: string;
    name: string;
    uiShouldBeHidden: boolean;

    static FromJson(json: any): Retailer {
        const o: Retailer = new Retailer();
        o.id = json['id'];
        o.code = json['code'];
        o.name = json['name'];
        o.code = o.code.replace(" ", "").replace("/", "").trim();
        return o;
    }
    
}